import { CircularProgress } from "@mui/material";
import { snack } from "components/Snack/Snack";
import { PAYMENT_METHOD } from "data/paymentConts";
import React, { useEffect, useState } from "react";
import paymentsService from "services/admin/paymentsService";

const PaymentMethodStats = ({ month }) => {
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState(null)
  const [error, setError] = useState(null)


  useEffect(() => {
    if (data) {
      const ctx = document.getElementById("paymentMethods");

      new window.Chart(ctx, {
        type: "pie",
        data: {
          labels: data.map(t => `${PAYMENT_METHOD[t.paymentMethod]}, ${t.total} $`),
          datasets: [
            {
              label: "Выручка",
              data: data.map(t => t.total),
              borderWidth: 1,
            },
          ],
        },
        options: {
          plugins: {
            legend: {
              display: true,
              position: 'bottom'
            }
          },
          scales: {
            y: {
              beginAtZero: true,
            },
          },
        },
      });
    }
  }, [data]);


  useEffect(() => {
    loadData()
  }, [month])

  async function loadData() {
    try {
      setLoading(true)
      const result = await paymentsService.getPaymentsMethodCounts({ month })
      setData(result.data)
    } catch (ex) {
      console.error(`PaymentMethodStats ex: `, ex)
      snack(ex?.message)
      setError(ex?.message)
    } finally {
      setLoading(false)
    }
  }

  if (loading) {
    return <div className="text-center"><CircularProgress></CircularProgress></div>
  }

  if (error) {
    return <div>{error}</div>
  }

  return (
    <div style={{ width: "300px" }}>
      <h3 className="text-center">Методы оплаты, $</h3>
      <p className="color-gray fs-12 m-t-8">Этот вид статистики полезен для анализа предпочтений клиентов и позволяет оценить, какие методы оплаты наиболее востребованы.</p>
      <canvas id="paymentMethods" style={{ width: 300 }}></canvas>
    </div>
  );
};

export default PaymentMethodStats